module.exports = {
	"description": "Popover component",
	"methods": [
		{
			"name": "addDocumentEventListeners",
			"docblock": null,
			"modifiers": [],
			"params": [],
			"returns": null
		},
		{
			"name": "close",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "Object",
						"alias": "Object"
					}
				}
			],
			"returns": null
		},
		{
			"name": "closeActions",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "Object",
						"alias": "Object"
					}
				}
			],
			"returns": null
		},
		{
			"name": "focusContent",
			"docblock": null,
			"modifiers": [],
			"params": [],
			"returns": null
		},
		{
			"name": "focusTrigger",
			"docblock": null,
			"modifiers": [],
			"params": [],
			"returns": null
		},
		{
			"name": "handleDocumentClick",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "Object",
						"alias": "Object"
					}
				}
			],
			"returns": null
		},
		{
			"name": "handleDocumentKeydown",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "Object",
						"alias": "Object"
					}
				}
			],
			"returns": null
		},
		{
			"name": "isClickOutsideComponent",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "Object",
						"alias": "Object"
					}
				}
			],
			"returns": null
		},
		{
			"name": "isControlled",
			"docblock": null,
			"modifiers": [],
			"params": [],
			"returns": null
		},
		{
			"name": "open",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "Object",
						"alias": "Object"
					}
				}
			],
			"returns": null
		},
		{
			"name": "openActions",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "Object",
						"alias": "Object"
					}
				}
			],
			"returns": null
		},
		{
			"name": "removeDocumentEventListeners",
			"docblock": null,
			"modifiers": [],
			"params": [],
			"returns": null
		},
		{
			"name": "toggleOpenState",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "Object",
						"alias": "Object"
					}
				}
			],
			"returns": null
		}
	],
	"props": {
		"autoFocus": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Focuses the Popover content when opened",
			"defaultValue": {
				"value": "true",
				"computed": false
			}
		},
		"children": {
			"flowType": {
				"name": "MnrlReactNode"
			},
			"required": true,
			"description": "Trigger for the Popover"
		},
		"content": {
			"flowType": {
				"name": "React$Element",
				"elements": [
					{
						"name": "unknown"
					}
				],
				"raw": "React$Element<*>"
			},
			"required": true,
			"description": "Content of the Popover"
		},
		"disabled": {
			"flowType": {
				"name": "boolean"
			},
			"required": true,
			"description": "Disables the Popover"
		},
		"hasArrow": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Include an arrow on the Popover content pointing to the trigger",
			"defaultValue": {
				"value": "true",
				"computed": false
			}
		},
		"isOpen": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "For use with controlled components, in which the app manages Popover state"
		},
		"modifiers": {
			"flowType": {
				"name": "Object"
			},
			"required": false,
			"description": "Plugins that are used to alter behavior. See [PopperJS docs](https://popper.js.org/popper-documentation.html#modifiers) for options."
		},
		"onClose": {
			"flowType": {
				"name": "signature",
				"type": "function",
				"raw": "(event: Object) => void",
				"signature": {
					"arguments": [
						{
							"name": "event",
							"type": {
								"name": "Object"
							}
						}
					],
					"return": {
						"name": "void"
					}
				}
			},
			"required": false,
			"description": "Called when Popover is closed"
		},
		"onOpen": {
			"flowType": {
				"name": "signature",
				"type": "function",
				"raw": "(event: Object) => void",
				"signature": {
					"arguments": [
						{
							"name": "event",
							"type": {
								"name": "Object"
							}
						}
					],
					"return": {
						"name": "void"
					}
				}
			},
			"required": false,
			"description": "Called when Popover is opened"
		},
		"defaultIsOpen": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Open the Popover immediately upon initialization"
		},
		"placement": {
			"flowType": {
				"name": "union",
				"raw": "| 'auto'\n| 'auto-end'\n| 'auto-start'\n| 'bottom'\n| 'bottom-end'\n| 'bottom-start'\n| 'left'\n| 'left-end'\n| 'left-start'\n| 'right'\n| 'right-end'\n| 'right-start'\n| 'top'\n| 'top-end'\n| 'top-start'",
				"elements": [
					{
						"name": "literal",
						"value": "'auto'"
					},
					{
						"name": "literal",
						"value": "'auto-end'"
					},
					{
						"name": "literal",
						"value": "'auto-start'"
					},
					{
						"name": "literal",
						"value": "'bottom'"
					},
					{
						"name": "literal",
						"value": "'bottom-end'"
					},
					{
						"name": "literal",
						"value": "'bottom-start'"
					},
					{
						"name": "literal",
						"value": "'left'"
					},
					{
						"name": "literal",
						"value": "'left-end'"
					},
					{
						"name": "literal",
						"value": "'left-start'"
					},
					{
						"name": "literal",
						"value": "'right'"
					},
					{
						"name": "literal",
						"value": "'right-end'"
					},
					{
						"name": "literal",
						"value": "'right-start'"
					},
					{
						"name": "literal",
						"value": "'top'"
					},
					{
						"name": "literal",
						"value": "'top-end'"
					},
					{
						"name": "literal",
						"value": "'top-start'"
					}
				]
			},
			"required": false,
			"description": "Placement of the Popover",
			"defaultValue": {
				"value": "'bottom'",
				"computed": false
			}
		},
		"restoreFocus": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Focuses trigger when Popover is closed",
			"defaultValue": {
				"value": "true",
				"computed": false
			}
		},
		"subtitle": {
			"flowType": {
				"name": "MnrlReactNode"
			},
			"required": false,
			"description": "Subtitle displayed under the title"
		},
		"title": {
			"flowType": {
				"name": "MnrlReactNode"
			},
			"required": false,
			"description": "Title of the Popover"
		},
		"trigger": {
			"flowType": {
				"name": "React$Element",
				"elements": [
					{
						"name": "unknown"
					}
				],
				"raw": "React$Element<*>"
			},
			"required": false,
			"description": "@Private Custom trigger component"
		},
		"triggerRef": {
			"flowType": {
				"name": "Function"
			},
			"required": false,
			"description": "@Private Ref for the Popover trigger"
		},
		"wrapContent": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Display the content with default styles",
			"defaultValue": {
				"value": "true",
				"computed": false
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-docgen-loader!./src/Popover/Popover.js
// module id = 1640
// module chunks = 0